
import React, { useState, useRef } from 'react';
import { summary } from 'framer-motion/client';
import GenericCardComponent from '../GenericCardComponent';
import siteConfig from '../../configuration/siteConfiguration';


export const CubeIcon = ({ bg = '#F5F7FA', color = '#072C55' }) => (
    <span
        className="generic-card-icon"
        style={{
            background: bg,
            '--icon-default-color': color,
        }}
    >
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.2" d="M4.13848 9.32715C4.04779 9.48098 3.99997 9.65629 4 9.83486V22.1652C4 22.3426 4.04721 22.5168 4.13679 22.67C4.22637 22.8232 4.35509 22.9498 4.50974 23.0367L15.5097 29.2242C15.6594 29.3085 15.8283 29.3527 16 29.3527L16.0013 29.3527L16.1186 16L4.1385 9.32716L4.13848 9.32715Z" />
            <path d="M28 22.1651V9.83484C28 9.6574 27.9528 9.48316 27.8632 9.32999C27.7736 9.17683 27.6449 9.05025 27.4903 8.96326L16.4903 2.77576C16.3406 2.69157 16.1717 2.64734 16 2.64734C15.8283 2.64734 15.6594 2.69157 15.5097 2.77576L4.50974 8.96326C4.35509 9.05025 4.22637 9.17683 4.13679 9.32999C4.04721 9.48316 4 9.6574 4 9.83484V22.1651C4 22.3426 4.04721 22.5168 4.13679 22.67C4.22637 22.8232 4.35509 22.9497 4.50974 23.0367L15.5097 29.2242C15.6594 29.3084 15.8283 29.3526 16 29.3526C16.1717 29.3526 16.3406 29.3084 16.4903 29.2242L27.4903 23.0367C27.6449 22.9497 27.7736 22.8232 27.8632 22.67C27.9528 22.5168 28 22.3426 28 22.1651Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M27.8623 9.32827L16.1188 16L4.13867 9.32715" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.1183 16L16.001 29.3527" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </span>
);

export const HICon = ({ icon }) => {
    return (
        <img
            src={`${siteConfig.assetBaseUrl}/icons/legal/what-indiaverdict-does/default-state/${icon}`}
            alt=""
            onMouseOver={e => (e.currentTarget.src = `${siteConfig.assetBaseUrl}/icons/legal/what-indiaverdict-does/hover-state/${icon}`)}
            onMouseOut={e => (e.currentTarget.src = `${siteConfig.assetBaseUrl}/icons/legal/what-indiaverdict-does/default-state/${icon}`)}

            style={{ width: 32, height: 32 }}
        />
    );
};

const ProductUseCases = ({ title, useCaseDetails }) => {
    const [slide, setSlide] = useState(0);
    const CARDS_PER_SLIDE = 4;
    const useCases = useCaseDetails?.useCases || [];
    const numSlides = useCases?.length > 0 ? Math.ceil(useCases.length / CARDS_PER_SLIDE) : 0;
    const dragStartX = useRef(null);
    const dragging = useRef(false);

    const startIdx = slide * CARDS_PER_SLIDE;
    const visibleCards = useCases?.length > 0 ? useCases.slice(startIdx, startIdx + CARDS_PER_SLIDE) : [];

    const goToSlide = (idx) => {
        if (idx >= 0 && idx < numSlides) setSlide(idx);
    };

    // Mouse drag logic
    const onMouseDown = (e) => {
        dragging.current = true;
        dragStartX.current = e.clientX;
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
    };
    const onMouseMove = (e) => {
        if (!dragging.current) return;
        // Optionally, you could add visual feedback here
    };
    const onMouseUp = (e) => {
        if (!dragging.current) return;
        const diff = e.clientX - dragStartX.current;
        if (Math.abs(diff) > 50) {
            if (diff < 0 && slide < numSlides - 1) goToSlide(slide + 1);
            if (diff > 0 && slide > 0) goToSlide(slide - 1);
        }
        dragging.current = false;
        dragStartX.current = null;
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
    };

    // Touch drag logic (remains the same)
    const onTouchStart = (e) => {
        dragging.current = true;
        dragStartX.current = e.touches[0].clientX;
    };
    const onTouchEnd = (e) => {
        if (!dragging.current) return;
        const endX = e.changedTouches[0]?.clientX ?? 0;
        const diff = endX - dragStartX.current;
        if (Math.abs(diff) > 50) {
            if (diff < 0 && slide < numSlides - 1) goToSlide(slide + 1);
            if (diff > 0 && slide > 0) goToSlide(slide - 1);
        }
        dragging.current = false;
        dragStartX.current = null;
    };
    const onTouchMove = (e) => {
        if (dragging.current) e.preventDefault();
    };

    return (
        <section className="uco-section">
            <div className="wave-bg">
                <img src="/images/wave.svg" alt="" />
            </div>
            <div className="uco-badge">{ }</div>
            <div className="uco-title-row">
                <h2 className="uco-title">Use Cases We Solve</h2>
            </div>
            <div
                className="uco-cards"
                onMouseDown={onMouseDown}
                onTouchStart={onTouchStart}
                onTouchEnd={onTouchEnd}
                onTouchMove={onTouchMove}
                style={{ cursor: 'grab', userSelect: 'none' }}
            >
                <GenericCardComponent cards={visibleCards} className="uco-cards-inner" />
            </div>
            <div className="uco-nav">
                <span
                    className="uco-arrow"
                    onClick={() => goToSlide(slide - 1)}
                    style={{ opacity: slide === 0 ? 0.3 : 1 }}
                >
                    ←
                </span>
                <div className="uco-dots-group">
                    {[...Array(numSlides)].map((_, idx) => (
                        <span
                            key={idx}
                            className={`uco-dot${slide === idx ? ' uco-dot--active' : ''}`}
                            onClick={() => goToSlide(idx)}
                            style={{ cursor: 'pointer' }}
                        />
                    ))}
                </div>
                <span
                    className="uco-arrow"
                    onClick={() => goToSlide(slide + 1)}
                    style={{ opacity: slide === numSlides - 1 ? 0.3 : 1 }}
                >
                    →
                </span>
            </div>
        </section>
    );
};

export default ProductUseCases; 